// ENTITY com.ic2.auth.mfa.MfaStatusDTO generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class MfaStatusDTO {

  static readonly __ic2_fqn: string = 'com.ic2.auth.mfa.MfaStatusDTO';

  totpEnabled: boolean | null = false;
  backupCodesLeft: number | null = 0;
  totpMayBeDisabled: boolean | null = false;

  constructor(init?:Partial<MfaStatusDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['com.ic2.auth.mfa.MfaStatusDTO'] = MfaStatusDTO;

fields['com.ic2.auth.mfa.MfaStatusDTO']  = {
    totpEnabled: 'java.lang.Boolean',
    backupCodesLeft: 'java.lang.Integer',
    totpMayBeDisabled: 'java.lang.Boolean'
};
